<div class="min-logos centerWidth">
    <div class="main-success-header col-12 block md:flex   ">
        <div class="col-12 md:col-6 more-title" ><h2 i18n="@@Brands who trust in Searchia">Brands who trust in Searchia</h2></div>
        <div class="col-12 md:col-6 more-div md:text-end text-center" >
<!--            <div class="more-btn  ">-->
<!--                <span i18n="@@See more">See more</span><i class="pi pi-angle-left"></i>-->
<!--            </div>-->
        </div>
    </div>
    <div class="col-12 flex flex-wrap">
        <ng-container *ngFor="let brand of brands">
            <div class="col-12  sm:col-6 md:col-4 lg:col-2  succ-img">
                <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +brand['img-uid'] "
                     [alt]="brand['img-name']">
            </div>
        </ng-container>

    </div>

</div>
